import React, { useState, useEffect, useContext } from "react";
import {
  Collapse,
  Button,
  CardBody,
  Card,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight, faTrash } from "@fortawesome/free-solid-svg-icons";
import AppContext from "../../../../../../Context/AppContext";
import { useSelector } from "react-redux";
import { canFieldAccess } from "./../../../../../../common/util/appUtils";
import AwsServerService from "../../../../../../common/util/AwsServerService";
import RoleSelectionForAccount from "../../../../../Accounts/ClientLayout/RoleSelectionForAccount";

const RoleSelectionForDeal = (props) => {
  const [roleToggleState, setRoleToggleState] = useState(false);
  const [roles, setRoles] = useState([]);
  const [roleDescription, setRoleDescription] = useState("");
  const AppData = useContext(AppContext);
  const { dispatch, state } = AppData || {};
//   const accessContext = useSelector(state => state.UserContext?.accessContext); 
  const ModuleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
  useEffect(() => {debugger
    let clientId;
    if(props.isEditDeal){
    clientId = props.data?.Client?.id;
    }else{
      clientId = props.clients?.find(e=>(props.client === e.name))?.id;
    }
    if (clientId) {
      AwsServerService.getRolesByProjectId(clientId).then(async (response) => {
         let arr=response || [];
          if(props.isEditDeal){
            await AwsServerService.getRolesByProjectId(`"${props.dealName}"`).then((res) => {
              arr=[...arr,...res];
            })
          }
          const rolesData = await AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => {
            return res?.data
          }).catch(err => {
            console.log(err);
          })
          const updatedRoles = [];
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];

            const moduleOptions =
              item.UserType === "Deal"
                ? Object.values(ModuleContacts || {}).flat()
                : ModuleContacts?.[item.UserType] || [];

            const moduleData = moduleOptions.find(
              (o) => o.id === item.UserId
            );

            const role = rolesData.find(
              (r) => r.ROWID === item.RoleId
            );
            updatedRoles.push({
              ...item,
              UserName:
                moduleData?.Full_Name || moduleData?.name || "N/A",
              RoleName: role?.RoleName || "N/A",
            });
          }
          setRoles(updatedRoles);
        })
        .catch((error) => {
          console.error("Error fetching roles for client:", error);
        });
    }
  }, [props?.client,props.data]);

  const handleRoleToggle = () => {
    setRoleToggleState(!roleToggleState);
    props.setListState("role");
    props.settoggleState("role");
  };

  const handleRoleCheck = () => {
    if (roles.length > 0) {
      props.setRolesComplete.rolesComplete = true;
      return true;
    }
    props.setRolesComplete.rolesComplete = false;
    return false;
  };  

  useEffect(() => {
    if (props.toggleState === "role") {
      setRoleToggleState(true);
    } else if (props.toggleState) {
      setRoleToggleState(false);
    }
  }, [props.toggleState]);

  const isAccessible = true;
//   canFieldAccess(accessContext, "Deals", "Roles", "All Roles") !== "DontShow";
  const isEditable = true;
//   canFieldAccess(accessContext, "Deals", "Roles", "All Roles") === "Create";

  return (
    <Col sm={12}>
      <Button
        onClick={handleRoleToggle}
        className={roleToggleState ? "btn-100-active" : "btn-100"}
      >
        Role Assignement
        <div className="float-right">
          <Input
            type="checkbox"
            id="roleCheckBox"
            className={
              handleRoleCheck()
                ? "rightbutton-checkbox-active"
                : "rightbutton-checkbox"
            }
            checked={handleRoleCheck()}
          />
          {roleToggleState ? (
            <FontAwesomeIcon className="font-centered" icon={faAngleDown} />
          ) : (
            <FontAwesomeIcon className="font-centered" icon={faAngleRight} />
          )}
        </div>
      </Button>
      <Collapse isOpen={roleToggleState}>
        <Card className="createdeal-card">
          <CardBody>
             <RoleSelectionForAccount setRoles={setRoles} roles={roles} module={"deal"}/>
          </CardBody>
        </Card>
      </Collapse> 
    </Col>
  );
};

export default RoleSelectionForDeal;
